/**
 * External dependencies
 */
import React, { Component } from 'react';

/**
 * Internal dependencies
 */
import FlashMessage from 'components/flash-message';
import cscom from 'lib/customer-site-api';

import styles from './styles.scss';

class AccountMessagesBanner extends Component {

	state = {
		messages: [],
		dismissedIds: [],
	};

	componentDidMount() {
		cscom
			.accountMessage()
			.list()
			.then((messages) => this.setState({ messages: messages || [] }))
			.catch(() => null);
	}

	handleDismiss = (id) => {
		this.setState((state) => ({
			dismissedIds: [...state.dismissedIds, id],
		}));
	};

	render() {
		const { messages, dismissedIds } = this.state;
		const visibleMessages = messages.filter((message) => !dismissedIds.includes(message.id));

		if (visibleMessages.length === 0) {
			return null;
		}

		return (
			<div className='account-messages-banner'>
				{visibleMessages.map((message) => (
					<FlashMessage
						key={message.id}
						info={message.message_type === 'info'}
						success={message.message_type === 'success'}
						error={message.message_type === 'error'}
						warning={message.message_type === 'warning'}
						closeButton
						onClick={() => this.handleDismiss(message.id)}
					>
						<div dangerouslySetInnerHTML={{ __html: message.message }} />
					</FlashMessage>
				))}
			</div>
		);
	}
}

export default AccountMessagesBanner;
